import { Controller } from "@hotwired/stimulus"
import { isValidDateOrRangeFormat } from "../../util"

export default class extends Controller {
  static targets = ["period", "input"]
  static values = { filterKey: String }

  connect() {
    this.lastNotifiedValue = this.inputTarget.value

    this.inputTarget.addEventListener("change", this.filterChanged.bind(this))
    this.inputTarget.addEventListener("filter:clear", this.clearFilter.bind(this))

    if (this.hasPeriodTarget) {
      this.periodTarget.addEventListener("change", this.handlePeriodChange.bind(this))
    }

    setTimeout(() => this.dispatchInitializedEvent(), 0)
  }

  dispatchInitializedEvent() {
    const event = new CustomEvent("filter:initialized", {
      detail: { label: this.getLabel(), value: this.getValue(), filterKey: this.filterKeyValue }
    })

    this.inputTarget.dispatchEvent(event)
  }

  handlePeriodChange(event) {
    const value = event.target.value
    if (!value) {
      this.inputTarget.value = ""
      if (this.inputTarget.picker) {
        this.inputTarget.picker.clear()
      }
    }
  }

  filterChanged(event) {
    const value = event?.target?.value
    if (value && !isValidDateOrRangeFormat(value)) {
      return
    }

    if (this.isUnchangedValue()) {
      return
    }

    this.lastNotifiedValue = this.getValue()

    const customEvent = new CustomEvent("filter:change", {
      detail: { label: this.getLabel(), value: this.getValue(), filterKey: this.filterKeyValue }
    })

    this.inputTarget.dispatchEvent(customEvent)
  }

  isUnchangedValue() {
    return this.getValue() === this.lastNotifiedValue
  }

  clearFilter() {
    this.inputTarget.value = ""
    this.inputTarget.picker.clear()
    if (this.hasPeriodTarget) {
      this.periodTarget.tomselect.clear()
    }
    this.inputTarget.dispatchEvent(new Event("change"))
  }

  getLabel() {
    return this.inputTarget.value
  }

  getValue() {
    return this.inputTarget.value
  }
}
